import getLang from 'I18n/utils/getLang';
import { useGetSatisfyingCombosBatchQuery } from '../../__generated__/chirp/com/hubspot/scopegaps/rpc/ScopeGapsService.hooks';
export function useFeatureCompatibilities({
  appContext,
  features,
  productType
}) {
  const isPublic = appContext === 'public';
  const isAdminPreview = appContext === 'admin-preview';
  const filteredFeatures = productType !== 'APP' ? features //skip check for featureLocation for non-apps
  : features.filter(feature => {
    var _feature$featureLocat, _feature$featureLocat2;
    return (_feature$featureLocat = feature === null || feature === void 0 || (_feature$featureLocat2 = feature.featureLocation) === null || _feature$featureLocat2 === void 0 ? void 0 : _feature$featureLocat2.includes('MARKETPLACE_LISTING')) !== null && _feature$featureLocat !== void 0 ? _feature$featureLocat : false;
  });
  const requestPayloads = [];
  filteredFeatures.forEach(feature => {
    var _feature$featureInter, _feature$featureScope;
    const scopes = ((_feature$featureInter = feature.featureInternalScopes) === null || _feature$featureInter === void 0 ? void 0 : _feature$featureInter.filter(scope => scope !== '').map(scope => scope.replaceAll('_', '-').toLowerCase())) || [];
    const scopeGroups = ((_feature$featureScope = feature.featureScopeGroups) === null || _feature$featureScope === void 0 ? void 0 : _feature$featureScope.filter(scopeGroup => scopeGroup !== '')) || [];
    requestPayloads.push({
      frontendLocale: getLang(),
      minimal: true,
      scopes,
      scopeGroups
    });
  });
  const {
    data,
    loading,
    error
  } = useGetSatisfyingCombosBatchQuery({
    variables: {
      requests: requestPayloads
    },
    skip: isPublic || filteredFeatures.length === 0 || isAdminPreview
  });
  const result = {};
  data === null || data === void 0 || data.results.forEach((featureData, index) => {
    if (index < filteredFeatures.length) {
      result[filteredFeatures[index].featureName] = featureData;
    }
  });
  return {
    result,
    loading,
    error
  };
}